import { Modal } from 'antd';
import { MODAL_DISCARD_BUTTON_COLOR } from 'app-constants';

export default (onDiscard: () => void, closedByBlur: boolean, hasUnsavedChanges: boolean) => {
  if (closedByBlur && hasUnsavedChanges) {
    Modal.confirm({
      title: 'There are unsaved changes',
      content: 'Are you sure you want to exit without saving?',
      okText: 'Discard',
      cancelText: 'Cancel',
      okButtonProps: {
        style: {
          background: MODAL_DISCARD_BUTTON_COLOR,
          borderColor: MODAL_DISCARD_BUTTON_COLOR,
        },
      },
      onOk: () => {
        onDiscard();
      },
    });
  } else {
    onDiscard();
  }
};
